import React from "react";
import Header from "@/components/jp/Header";
import Menu from "@/components/jp/Menu";
import Footer from "@/components/jp/Footer";
import FloatingButton from "@/components/jp/FloatingButton";
import ScrollToTopFab from "@/components/jp/ScrollToTopFab";
import ListImage from "@/components/jp/instrument_introduction/ListImage";
import ListTable from "@/components/jp/instrument_introduction/ListTable";
import Link from "next/link";
import Image from "next/image";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import CircleIcon from "@mui/icons-material/Circle";
import Stack from "@mui/material/Stack";
import PCStep from "@/public/static/images/instrument_step_jp.png";
import MBStep1 from "@/public/static/images/step-1_jp.png";
import MBStep2 from "@/public/static/images/step-2_jp.png";
import MBStep3 from "@/public/static/images/step-3_jp.png";
import Env1 from "@/public/static/images/instrument/env-1.png";
import Env2 from "@/public/static/images/instrument/env-2.png";
import SAbout from "@/public/static/images/opacity_about.png";
import SPorcess from "@/public/static/images/opacity_process.png";
import SNews from "@/public/static/images/opacity_news.png";

const breadcrumbs = [
  <Link key="1" href="/">
    ホーム
  </Link>,
  <Typography key="2">設備概要</Typography>,
];

function Instrument() {
  return (
    <div className="wrapper">
      <Header />
      <Menu />

      <div className="coverMain">
        <div className="container">
          <div className="row">
            <Grid
              container
              spacing={2}
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
            >
              <Grid item xs={12}>
                <Typography
                  variant="h3"
                  noWrap
                  sx={{
                    mr: 2,
                    mb: 1,
                    fontFamily: "Titillium Web",
                    fontWeight: 800,
                    letterSpacing: ".1rem",
                    color: "#fff",
                    textDecoration: "none",
                  }}
                >
                  <CircleIcon
                    sx={{ mb: 1, mr: 2, fontSize: "18px", color: "#0179CC" }}
                  />
                  設備概要
                </Typography>
                <Breadcrumbs
                  separator={<NavigateNextIcon fontSize="small" />}
                  aria-label="breadcrumb"
                  className="breadcrumbs"
                >
                  {breadcrumbs}
                </Breadcrumbs>
              </Grid>
            </Grid>
          </div>
        </div>
      </div>

      <div className="content">
        <div className="container">
          <div className="row">
            <Box sx={{ display: { xs: "none", md: "flex" }, mr: 1, mb: 3 }}>
              <Image
                loading="lazy"
                src={PCStep}
                alt="Instrument Introduction"
                className="logo_login"
                sizes="100vw"
                style={{
                  width: "100%",
                  height: "auto",
                }}
              />
            </Box>
            <Box sx={{ display: { xs: "block", md: "none" }, mr: 1, mb: 3 }}>
              <div className="col-12 mb-1">
                <Image
                  loading="lazy"
                  src={MBStep1}
                  alt="Instrument Introduction"
                  className="logo_login"
                  width={300}
                />
              </div>
              <div className="col-12 mb-1">
                <Image
                  loading="lazy"
                  src={MBStep2}
                  alt="Instrument Introduction"
                  className="logo_login"
                  width={300}
                />
              </div>
              <div className="col-12 mb-1">
                <Image
                  loading="lazy"
                  src={MBStep3}
                  alt="Instrument Introduction"
                  className="logo_login"
                  width={300}
                />
              </div>
            </Box>
            <div className="col-12 my-5">
              <ListImage />
            </div>
            <div className="col-12 my-3">
              <ListTable />
            </div>

            <div className="col-12 py-3">
              <div className="sub-inner_headding">
                <h5 className="mb-0">環境対応</h5>
              </div>
            </div>
            <div className="col-12 env-img">
              <p>タイ、工業団地の環境基準に沿い大型排水処理設備で処理</p>
              <div className="row">
                <div className="col-12 col-sm-8 h-100">
                  <Image
                    loading="lazy"
                    src={Env1}
                    alt="Instrument Introduction"
                    className="logo_login"
                    sizes="100vw"
                    style={{
                      width: "100%",
                      height: "auto",
                    }}
                  />
                </div>
                <div className="col-12 col-sm-4 h-100">
                  <Image
                    loading="lazy"
                    src={Env2}
                    alt="Instrument Introduction"
                    className="logo_login"
                    sizes="100vw"
                    style={{
                      width: "100%",
                      height: "auto",
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <section className="sub-contact mt-5">
        <div className="sub-contact-inner">
          <Stack
            direction={{ xs: "column", sm: "row" }}
            spacing={{ xs: 0, sm: 0, md: 0 }}
            justifyContent="center"
            alignItems="center"
          >
            <Link href="/processusage">
              <div className="card card-subcontact bg-darkblue">
                <Image
                  loading="lazy"
                  src={SPorcess}
                  alt="Process & Usage"
                  className="card-img"
                  width={300}
                />
                <div className="card-img-overlay d-flex justify-content-center align-items-center">
                  <h1 className="mb-0 fw-bold">加工・用途紹介</h1>
                </div>
              </div>
            </Link>
            <Link href="/news">
              <div className="card card-subcontact bg-blue">
                <Image
                  loading="lazy"
                  src={SNews}
                  alt="News"
                  className="card-img"
                  width={300}
                />
                <div className="card-img-overlay d-flex justify-content-center align-items-center">
                  <h1 className="mb-0 fw-bold">ニュース</h1>
                </div>
              </div>
            </Link>
            <Link href="/aboutus">
              <div className="card card-subcontact bg-darkblue">
                <Image
                  loading="lazy"
                  src={SAbout}
                  alt="About Us"
                  className="card-img"
                  width={300}
                />
                <div className="card-img-overlay d-flex justify-content-center align-items-center">
                  <h1 className="mb-0 fw-bold">会社概要</h1>
                </div>
              </div>
            </Link>
          </Stack>
        </div>
      </section>
      <FloatingButton />
      <ScrollToTopFab />
      <Footer />
    </div>
  );
}

export default Instrument;
